<template>
  <div class="detail-container">
    <div class="detail-header">
      <div class="detail-header-info-avatar">
        <b-skeleton-wrapper
          class="d-flex flex-column align-items-center"
          :loading="isLoading"
        >
          <template #loading>
            <b-skeleton type="avatar" width="64px" height="64px" />
          </template>
          <img :src="getAvatar(currentConversation.photo)" alt="avatar" />
        </b-skeleton-wrapper>
      </div>
      <div class="detail-header-title">
        <b-skeleton-wrapper
          class="d-flex flex-column align-items-center"
          :loading="isLoading"
        >
          <template #loading>
            <b-skeleton width="200px" height="20px" />
            <b-skeleton width="170px" height="20px" />
          </template>
          <span class="detail-header-title-text">
            {{ currentConversation.name.nome }}
            <i
              class="fa fa-info-circle"
              :title="getOrigemDisplayName(currentConversation)"
            ></i>
          </span>
          <span class="detail-header-title-document" v-if="document"
            >{{ documentType }}: {{ document }}</span
          >
          <span v-else>Não é cooperado</span>
        </b-skeleton-wrapper>
      </div>

      <b-button
        v-if="person.id !== null && !isLoading"
        variant="link"
        style="color: #006a5b !important;"
        @click="showAssociadoModal(selectedDocument)"
      >
        Detalhes do Associado <i class="fas fa-user mr-1" />
      </b-button>
    </div>
    <div class="detail-content">
      <div
        v-for="(detail, index) in details"
        :key="index"
        class="detail-content-item"
      >
        <b-skeleton-wrapper
          class="d-flex flex-column align-items-center"
          :loading="isLoading"
        >
          <template #loading>
            <b-skeleton width="100%" height="20px" />
            <b-skeleton width="100%" height="20px" />
          </template>
          <span class="detail-content-item-title">{{ detail.label }}</span>
          <span class="detail-content-item-value">{{ detail.value }}</span>
        </b-skeleton-wrapper>
      </div>
      <div v-show="detailsFinalization.length !== 0">
        <a
          href="javascript:void(0);"
          @click="toggleAll"
          class="toggle-all-button"
        >
          <i
            :class="showAll ? 'fas fa-eye-slash' : 'fas fa-eye'"
            style="font-size: 16px"
            v-b-tooltip.hover
          ></i>
          {{ showAll ? 'Esconder Atendimentos' : 'Mostrar Atendimentos' }}
        </a>

        <div v-if="showAll">
          <div
            v-for="(group, index) in groupedDetailsFinalization"
            :key="index"
            class="detail-content-item"
          >
            <div
              v-for="(final, idx) in group.details"
              :key="idx"
              class="detail-content-item-detail"
            >
              <div class="detail-content-item-detail-container">
                <span
                  class="detail-content-item-title-final"
                  @click="
                    handleClick(
                      final.conversationId,
                      final.provider,
                      final.identifierProvider
                    )
                  "
                  >{{ final.title }}</span
                >
                <span
                  class="detail-content-item-title"
                  @click="
                    handleClick(
                      final.conversationId,
                      final.provider,
                      final.identifierProvider
                    )
                  "
                  >{{ final.label }}</span
                >
                <span
                  class="detail-content-item-value"
                  @click="
                    handleClick(
                      final.conversationId,
                      final.provider,
                      final.identifierProvider
                    )
                  "
                >
                  {{ final.value }}
                </span>
                <!-- Aqui, usamos v-html para renderizar o ícone com base na condição -->
                <span v-if="final.icon" v-html="final.icon"></span>
              </div>
            </div>
          </div>
          <ChatModal ref="messagesModal" />
        </div>
      </div>
    </div>

    <div class="detailButton">
      <defaultbutton
        :onClick="showModalNewLead"
        btnVariant="btn-third"
        icon="fas fa-user-plus"
        text="criar oportunidade"
      />
      <defaultbutton
        :onClick="openNickModal"
        btnVariant="btn-third"
        icon="fas fa-pencil-alt"
        text="trocar apelido"
      />
      <defaultbutton
        :onClick="openAttachModal"
        btnVariant="btn-third"
        icon="fas fa-arrow-right"
        text="transferir"
      />
      <defaultbutton
        :onClick="openAttachModalFinaliza"
        btnVariant="btn-outline-third"
        icon="fas fa-user-slash"
        text="finalizar"
      />
    </div>
    <b-modal
      centered
      ref="modalTransfer"
      title="Transferir"
    >
    <b-tabs>
      <b-tab title="Transferir">
        <label for="username-select">Selecione um usuário:</label>
        <b-form-select
          id="username-select"
          v-model="selectedUsername"
          :options="usernames"
        ></b-form-select>

        <label style="margin-top:10px" for="observation">Observação:</label>
        <SimpleToggle
          style="margin-top: 10px;"
          :value="createObservationTransfer"
          @input="createObservationTransfer = $event"
          label="Adicionar Observação"
        />

        <div v-show="createObservationTransfer">
          <div style="margin-top: 10px;">
            <b-form-textarea
              id="observation"
              v-model="observationTranfer"
              placeholder="Observação"
              maxlength="90"
            ></b-form-textarea>
            <small v-if="observationTranfer" class="text-muted">
              {{ observationTranfer.length }}/90 caracteres
            </small>
          </div>
        </div>
      </b-tab>
    </b-tabs>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="sendUpdateOperator"
            v-b-tooltip.hover
            :title="'Transferir'"
          >
            <i class="fa fa-angle-double-right"></i
            ><span class="d-md-down-none"> Transferir</span>
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal centered ref="modalFinaliza" title="Finalizar">
  <label for="username-select">Selecione o motivo da finalização:</label>
  <b-form-select
    id="username-select"
    v-model="selectedTipo"
    :options="tipos"
    required
  ></b-form-select>

  <label style="margin-top:10px" for="observation">Observação:</label>
  <SimpleToggle
    style="margin-top: 10px;"
    v-model="createObservationFinaliza"
    label="Adicionar Observação"
  />

  <div v-show="createObservationFinaliza">
    <div style="margin-top: 10px;">
      <b-form-textarea
        id="observation"
        v-model="observation"
        placeholder="Observação"
        maxlength="90"
      ></b-form-textarea>
      <small v-if="observation" class="text-muted">
        {{ observation.length }}/90 caracteres
      </small>

    </div>
  </div>

  <template #modal-footer>
    <div class="w-100 text-right">
      <button
        type="button"
        class="btn btn-third btn-sm"
        v-on:click="sendUpdateStatus"
        v-b-tooltip.hover
        :title="'Finalizar'"
      >
        <i class="fa fa-angle-double-right"></i>
        <span class="d-md-down-none"> Finalizar</span>
      </button>
    </div>
  </template>
</b-modal>
    <OportunidadeModal ref="OportunidadeModal" @Back="closeNewLeadModal" />
    <AssociadoResumo ref="AssociadoResumo" :document="person.document" />
    <ApelidoModal ref="apelidoModal" @onUpdate="onConversationsUpdated" />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import _ from 'lodash'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import ChatModal from '@/views/private/atendimento/components/details/components/ChatModal.vue'
import SimpleToggle from '@/components/UI/toogleSwitch/SimpleToggle.vue'
import AssociadoResumo from '@/components/nexum/modals/AssociadoResumo.vue'
import ApelidoModal from './components/ApelidoModal.vue'
import OportunidadeModal from '@/views/private/crm/board/modal/oportunidadeModal/OportunidadeModal.vue'

export default {
  name: 'Details',
  components: {
    defaultbutton,
    ChatModal,
    AssociadoResumo,
    SimpleToggle,
    ApelidoModal,
    OportunidadeModal
  },
  mixins: [AccountMixin],
  data () {
    return {
      showModalNewConversation: false,
      newConversationPerson: '',
      newConversationSubject: '',
      newConversationMessage: '',
      usernames: [],
      tipos: [],
      showModalTransfer: false,
      showModalFinaliza: false,
      selectedUsername: null,
      selectedTipo: null,
      observation: '',
      observationTranfer: '',
      createObservation: false,
      createObservationTransfer: false,
      createObservationFinaliza: false,
      showAll: false,
      messages: [],
      selectedDocument: this.person ? this.person.document : null,
      modalNewLeadOpen: false
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    person: {
      type: Object,
      required: false,
      default: () => null
    },
    currentConversation: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    details () {
      return [
        {
          label: 'Protocolo da Conversa',
          value: this.getValue(this.currentConversation.protocol)
        },
        {
          label: 'Telefone',
          value: this.formatPhoneNumberb(
            this.getValue(this.currentConversation.identifier)
          )
        },
        {
          label: `${this.$t('associates.number')}`,
          value: this.getValue(this.person.numSisbr, '-', this.numSisbr)
        },
        {
          label: 'Apelido',
          value: this.getValue(this.person.nickname, '-')
        },
        {
          label: 'Dt. Nascimento',
          value: this.dateFormat(this.getValue(this.person.dataNascimento))
        },
        {
          label: 'Dt. Início Relacionamento',
          value: this.dateFormat(
            this.getValue(this.person.inicioRelacionamento)
          )
        },
        {
          label: 'Gerente Rel.',
          value: this.getValue(this.person.gerenteRelacionamento, '-')
        },
        {
          label: 'Agente Rel.',
          value: this.getValue(this.person.agenteRelacionamento, '-')
        }
      ]
    },
    detailsFinalization () {
      if (
        !this.currentConversation ||
          !Array.isArray(this.currentConversation.finalizations)
      ) {
        return []
      }
      return this.currentConversation.finalizations
        .map(finalization => {
          let startDay = this.formatDay(finalization.dateCreated) + ' '
          let endDay = this.formatDay(finalization.dateFinalization) + ' '
          return [
            {
              title: 'Protocolo:',
              value: this.getValue(finalization.protocol, '-'),
              conversationId: finalization.conversationId
            },
            {
              label: 'Data de Criação:',
              value: this.getValue(startDay, '-'),
              conversationId: finalization.conversationId
            },
            {
              label: 'Data de Finalização:',
              value: this.getValue(endDay, '-'),
              conversationId: finalization.conversationId
            },
            {
              label: 'Tipo de Finalização:',
              value: this.getValue(finalization.type, '-'),
              conversationId: finalization.conversationId
            },
            {
              label: 'Condição:',
              value: this.getValue(
                finalization.condition ? 'Positivo' : 'Negativo'
              ),
              conversationId: finalization.conversationId,
              icon: finalization.condition
                ? '<i class="fa fa-thumbs-up text-success" icon="icon-like" for="title"></i>'
                : '<i class="fa fa-thumbs-down text-danger" icon="icon-like" for="title"></i>'
            }
          ]
        })
        .flat()
    },
    groupedDetailsFinalization () {
      const groups = []
      const itemsPerGroup = 5

      for (
        let i = 0;
        i < this.detailsFinalization.length;
        i += itemsPerGroup
      ) {
        groups.push({
          title: `Finalização ${Math.floor(i / itemsPerGroup) + 1}`,
          details: this.detailsFinalization
            .slice(i, i + itemsPerGroup)
            .map(detail => {
              return {
                ...detail,
                className:
                    detail.value === this.currentConversation.protocol
                      ? 'detail-content-item-final'
                      : 'detail-content-item-final'
              }
            })
        })
      }

      return groups
    },

    document () {
      if (_.isNil(this.person.document)) {
        return ''
      }

      return Tools.formatCpfCnpj(this.person.document, this.person.tipoPessoa)
    },
    documentType () {
      return this.person.tipoPessoa === 'PJ' ? 'CNPJ' : 'CPF'
    }
  },
  created () {
    if (this.currentConversation) {
      this.getUsernames()
    }
    this.getTiposFinalizacao()
  },
  watch: {
    currentConversation (newValue) {
      if (newValue) {
        this.getUsernames()
      }
    }
  },

  methods: {
    openNickModal () {
      this.$refs.apelidoModal.show(this.currentConversation)
    },
    getValue (value, defaultValue, format) {
      if (!value) return defaultValue
      if (format) {
        return new Date(value).toLocaleDateString()
      }
      return value
    },
    openAttachModal () {
      this.selectedUsername = null
      this.observationTranfer = null
      this.createObservation = false

      this.$refs.modalTransfer.show()
    },
    openAttachModalFinaliza () {
      this.selectedTipo = null
      this.observation = null
      this.createObservation = false

      this.$refs.modalFinaliza.show()
    },
    getOrigemDisplayName (conversation) {
      let origem = conversation.name.origem
      if (origem === 'Conversa') {
        return 'Esse nome é de uma conversa'
      } else if (origem === 'Campanha') {
        return 'Esse nome é de uma campanha'
      } else if (origem === 'Pessoa') {
        return 'Esse nome é de um associado'
      } else {
        return 'Nome não registrado'
      }
    },
    async getUsernames () {
      var requestConfig = {}
      if (this.account.administrador) {
        requestConfig = {
          permissions: [],
          paId: [],
          isAdm: this.account.administrador
        }
      } else {
        requestConfig = {
          permissions: this.account.permissoes,
          paId: this.account.funcionario.paId,
          isAdm: false
        }
      }
      try {
        const response = await AtendimentoRepository.GetUsenames(
          requestConfig
        )
        const { data } = response
        this.usernames = data.usernames.map(username => {
          return {
            text: username.nome,
            value: {
              username: username.username,
              nome: username.nome,
              id: username.id
            }
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async getTiposFinalizacao () {
      await AtendimentoRepository.GetTipos()
        .then(response => {
          const { data } = response
          this.tipos = data.tipos.map(tipo => ({ text: tipo, value: tipo }))
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {})
    },
    dateFormat (value) {
      if (value != null) {
        const datePart = value.split('T')[0]
        const [year, month, day] = datePart.split('-')
        return `${day}/${month}/${year}`
      }
      return ''
    },
    showAssociadoModal (document) {
      this.selectedDocument = document
      this.$refs.AssociadoResumo.openResumoAssociado()
    },
    sendUpdateOperator () {
      if (!this.selectedUsername) {
        this.$bvToast.toast(
          'Por favor, preencha todos os campos obrigatórios.',
          {
            title: 'Campos obrigatórios',
            variant: 'danger',
            solid: true
          }
        )
        return
      }
      const message = {
        conversationId: this.currentConversation.conversationId,
        operatorId: this.selectedUsername.id,
        username: this.selectedUsername.username,
        nameOperator: this.selectedUsername.nome.replace('\t', ''),
        identifier: this.currentConversation.identifier,
        name: this.currentConversation.name,
        provider: this.currentConversation.provider,
        event: 'transferir',
        deptoId: this.currentConversation.deptoId,
        protocol: this.currentConversation.protocol,
        description: this.observationTranfer,
        identifierProvider: this.currentConversation.identifierProvider
      }

      try {
        this.$emit('sendUpdateOperator', message)
      } catch (error) {
        console.error('Erro ao finalizar a tarefa:', error)
      } finally {
        this.$refs.modalTransfer.hide()
      }
    },
    async sendUpdateStatus () {
      if (!this.selectedTipo) {
        this.$bvToast.toast(
          'Por favor, preencha todos os campos obrigatórios.',
          {
            title: 'Campos obrigatórios',
            variant: 'danger',
            solid: true
          }
        )
        return
      }

      const message = {
        conversationId: this.currentConversation.conversationId,
        status: 'F',
        type: this.selectedTipo,
        observation: this.observation,
        nameOperator: this.account.pessoa.nome.replace('\t', ''),
        identifier: this.currentConversation.identifier,
        name: this.currentConversation.name,
        provider: this.currentConversation.provider,
        protocol: this.currentConversation.protocol,
        identifierProvider: this.currentConversation.identifierProvider
      }

      try {
        this.$emit('sendUpdateStatus', message)
      } catch (error) {
        console.error('Erro ao finalizar a tarefa:', error)
      } finally {
        this.$refs.modalFinaliza.hide()
      }
    },
    formatPhoneNumberb (phoneNumberString) {
      let cleaned = ('' + phoneNumberString)
        .replace(/\D/g, '')
        .replace('55', '')
      let match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return phoneNumberString
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    formatDay (isoString) {
      const date = new Date(isoString)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    formatTime (isoString) {
      const date = new Date(isoString)
      return `${date.getHours()}h:${date.getMinutes()}m:${date.getSeconds()}s`
    },
    toggleAll () {
      this.showAll = !this.showAll
    },
    handleClick (conversationId, provider, identifierProvider) {
      this.$refs.messagesModal.openAttachModalMessages(
        conversationId,
        provider,
        identifierProvider
      )
    },
    onConversationsUpdated () {
      this.$emit('onConversationsUpdated')
    },
    showModalNewLead () {
      this.$refs.OportunidadeModal.showModal()
    }
  }
}
</script>

<style scoped lang="scss">
  .detail-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: #fff;
    border-top: 1px solid #cfd8dc;
    border-bottom: 1px solid #cfd8dc;
    border-right: 1px solid #cfd8dc;
    padding: 14px;

    .detail-header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-bottom: #f1f2f6 solid 1px;

      .detail-header-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0.5rem;

        .detail-header-title-text {
          color: #1f2227 !important;
          font-size: 18px;
        }

        .detail-header-title-document {
          color: #1f2227 !important;
          font-size: 16px;
        }
      }

      .detail-header-info-avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 0.5rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          background-color: #e3e3e3;
        }
      }
    }

    .detail-content {
      display: flex;
      flex-direction: column;
      padding: 0.35rem;
      overflow-y: auto;
      flex: 1 1 0;

      .detail-content-item {
        display: flex;
        flex-direction: column;
        padding: 0.35rem;

        .detail-content-item-title {
          color: #434a54 !important;
          font-weight: 700;
          font-size: 13px;
          margin-right: 5px;
        }
        .detail-content-item-title-final {
          color: #1baca0 !important;
          text-decoration: underline;
          cursor: pointer;
          font-weight: 700;
          font-size: 13px;
          margin-right: 5px;
        }

        .detail-content-item-value {
          font-size: 13px;
          font-weight: 500;
        }
        .detail-content-item-final {
          font-size: 13px;
          color: #1baca0;
          cursor: pointer;
          text-decoration: underline;
          transition: color 0.3s ease;

          &:hover {
            color: #006400;
          }
        }
        .detail-content-item-noLink {
          font-size: 13px;
          font-weight: 500;
          color: #1f2227;
        }
      }
    }

    .detailButton {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      max-height: 285px;
    }
    .modal-content {
      width: 100%;
      height: 400px;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/details/Details.vue